export const marketsQueryKeys = {
  all: ['market'] as const,
  lists: () => [...marketsQueryKeys.all, 'list'] as const,
  list: () => [...marketsQueryKeys.lists()] as const,
}
